// Descrição: Opções expandíveis do sidebar (Sair, Configurações, etc.)

import * as React from "react";
import { styled } from "@mui/material/styles";
import Divider, { dividerClasses } from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MuiMenuItem from "@mui/material/MenuItem";
import { paperClasses } from "@mui/material/Paper";
import { listClasses } from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon, { listItemIconClasses } from "@mui/material/ListItemIcon";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";

import use123zapStore from "../../context/123zapStore";
import axios from "axios";

const MenuItem = styled(MuiMenuItem)({
  margin: "2px 0",
});

export default function OptionsMenu() {
  const userInfo = use123zapStore((state) => state.userInfo);

  const handleLogout = async () => {
    const FRONTURL_BASED = process.env.REACT_APP_FRONTEND_URL;
    const token = localStorage.getItem("jwt_token");

    if (userInfo["UUID"]) {
      await axios
        .post(`${process.env.REACT_APP_BACKEND_AWS_URL}/auth/logout`, {
          accessToken: token,
        })
        .then((response) => {
          console.log("response:", response);
          localStorage.removeItem("idToken");
          window.location.href = `${FRONTURL_BASED}`;
        })
        .catch((error) => {
          console.error("error:", error);
        })
        .finally(() => {
          localStorage.removeItem("idToken");
          localStorage.removeItem("jwt_token");
          window.location.href = `${FRONTURL_BASED}`;
        });
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      {/* Trigger do menu (ícone de 3 pontinhos) */}
      <MoreVertRoundedIcon
        onClick={handleClick}
        sx={{ cursor: "pointer" }}
      />

      <Menu
        anchorEl={anchorEl}
        id="menu"
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        sx={{
          [`& .${listClasses.root}`]: { padding: "4px" },
          [`& .${paperClasses.root}`]: { padding: 0 },
          [`& .${dividerClasses.root}`]: { margin: "4px -4px" },
        }}
      >
        {/* Aqui você pode adicionar outras opções se quiser */}
        <Divider />
        <MenuItem
          onClick={handleLogout}
          sx={{
            [`& .${listItemIconClasses.root}`]: {
              ml: "auto",
              minWidth: 0,
            },
          }}
        >
          <ListItemText>Logout</ListItemText>
          <ListItemIcon>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
